import { HIBA_SZOVEGEK, type IrodaRegisztracioKeres } from './urlap.ts';

export type MegerositesEredmeny = 'ok' | 'mar_megerositve' | 'lejart' | 'nincs';
export type HibaKod = keyof typeof HIBA_SZOVEGEK;
export type ApiEredmeny<T> = { ok: true; adat: T } | { ok: false; hiba: HibaKod };

/** Háttér-hibakódból felhasználói hibakulcs; ismeretlenből `szerver`. */
export function hibaKod(kod: unknown, statusz: number): HibaKod {
  if (typeof kod === 'string' && kod in HIBA_SZOVEGEK) return kod as HibaKod;
  return statusz === 429 ? 'korlat' : 'szerver';
}

/**
 * A két nyilvános Edge Function hívása. Belépés nélkül megy (verify_jwt = false), ezért a `supabase.functions.invoke`
 * helyett sima fetch, és ez a modul nem tölti be a Supabase-klienst.
 */
export function regisztracioApi(supabaseUrl: string, fetchFn: typeof fetch = (...a) => fetch(...a)) {
  const alap = `${supabaseUrl.replace(/\/+$/, '')}/functions/v1`;

  async function post<T>(ut: string, body: unknown): Promise<ApiEredmeny<T>> {
    let r: Response;
    try {
      r = await fetchFn(`${alap}/${ut}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    } catch {
      // Hálózati hiba: a hívó üzenetet mutat, és a felhasználó újrapróbálhatja.
      return { ok: false, hiba: 'halozat' };
    }
    const adat = (await r.json().catch(() => null)) as (Record<string, unknown> | null);
    if (r.ok && adat) return { ok: true, adat: adat as T };
    return { ok: false, hiba: hibaKod(adat?.hiba, r.status) };
  }

  return {
    bekuldes: (k: IrodaRegisztracioKeres) => post<{ ok: true }>('iroda-regisztracio', k),
    megerosites: (token: string) => post<{ eredmeny: MegerositesEredmeny }>('iroda-regisztracio-megerosites', { token }),
  };
}
